<template>
    <div class="ql-snow">
        <van-nav-bar :title="title" left-arrow @click-left="back"></van-nav-bar>
        <div class="info ql-editor" v-if="info" v-html="info.content"> </div>
    </div>
</template>
<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { mapGetters } from 'vuex';
import httpRequest from '@/module_visitor/api/http.js';
export default {
    name: 'info',
    data() {
        return {
            info: {},
            title: '',
            did: 0,
        };
    },
    computed: {
        ...mapGetters(['defaultInfo']),
    },
    mounted() {
        var { id } = this.$route.query;
        this.did = id;
        this.getInfo();
    },
    methods: {
        back() {
            this.$router.go(-1);
        },
        getInfo() {
            httpRequest
                .get('/api/article/getByTag', {
                    id: this.did,
                })
                .then(res => {
                    this.info = res.data.data;
                    this.title = res.data.data.title;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
.info {
    padding: 12px;
    ::v-deep img {
        width: 100%;
    }
}
</style>